import React, {useEffect, useRef, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation/src/elevation";
import {Container} from "@pg-design/grid-module";
import {flex, onDesktop, pb, pt, pv, textAlign, w100} from "@pg-design/helpers-css";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {debounce} from "@pg-mono/nodash";

import {useStickyIntersection} from "../../hooks/use_sticky_intersection";
import {doubleNavHeight} from "../../offer/components/InvestingOfferListViewNavigation";
import {ILatestQuery} from "../../utils/latest_query";
import {useInvestmentOfferFilters} from "../hooks/use_investment_offer_filters";
import {useInvestmentOfferViewsUrl} from "../hooks/use_investment_offer_views_url";
import {InvestmentOfferListDesktopFilters} from "../list/components/InvestmentOfferListDesktopFilters";

interface IProps {
    latestQuery?: ILatestQuery;
    hideSearchAndFilter?: boolean;
    setInvestmentOffersBlendActive: (active: boolean) => void;
    isMap?: boolean;
}

export const InvestmentListingStickyHeader = (props: IProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const isSticky = useStickyIntersection(wrapperRef);

    const {mapUrl, listUrl} = useInvestmentOfferViewsUrl();
    const {formValues: filtersFormValues, onChange: onFiltersChange} = useInvestmentOfferFilters();

    const [isScrollLowerThanDoubleNavHeight, setIsScrollLowerThanDoubleNavHeight] = useState(true);

    const getScrollPosition = () => {
        if (window.scrollY < doubleNavHeight !== isScrollLowerThanDoubleNavHeight) {
            setIsScrollLowerThanDoubleNavHeight(typeof window !== "undefined" ? window.scrollY < doubleNavHeight : true);
        }
    };
    const debouncedGetScrollPosition = debounce(getScrollPosition, 500);

    useEffect(() => {
        window.addEventListener("scroll", debouncedGetScrollPosition);
        return () => window.removeEventListener("scroll", debouncedGetScrollPosition);
    }, [debouncedGetScrollPosition]);

    return (
        <div ref={wrapperRef} css={[headerWrapperStyle, headerWrapperStickyStyle(isSticky)]}>
            <div css={stickyHeaderWrapperStyle(isSticky)}>
                <Container css={containerStyle}>
                    {!props.hideSearchAndFilter && !!props.latestQuery && (
                        <InvestmentOfferListDesktopFilters
                            onChange={(newFiltersValue) => onFiltersChange(newFiltersValue, true)}
                            setInvestmentOffersBlendActive={props.setInvestmentOffersBlendActive}
                            values={filtersFormValues}
                            isMap={!!props.isMap}
                            listUrl={listUrl}
                            isSticky={isSticky}
                        />
                    )}
                    <Button href={mapUrl} iconLeft={BrandMapPinIcon} variant="brand_icon" size="big" css={buttonStyle}>
                        Zobacz na mapie
                    </Button>
                </Container>
            </div>
        </div>
    );
};

const headerWrapperStyle = css`
    display: none;

    ${onDesktop(css`
        display: block;
        position: sticky;
        top: 0;

        height: 8rem;
        margin-bottom: -8rem;
    `)};
`;

const headerWrapperStickyStyle = (isSticky: boolean) =>
    isSticky
        ? css`
              z-index: 22;
          `
        : css`
              z-index: -1;
          `;

const stickyHeaderWrapperStyle = (isSticky: boolean) =>
    isSticky
        ? css`
              ${elevation(4)};
              ${pv(1)};
              background: white;
              width: 100%;
          `
        : css`
              visibility: hidden;
          `;

const buttonStyle = css`
    transition-duration: unset;
    transition-timing-function: unset;
    overflow: initial;
`;

const containerStyle = css`
    ${textAlign("left")};
    ${flex("center", "flex-start")};
    ${w100};

    > div:first-of-type {
        ${w100};
    }

    .isInNavigationBar {
        ${pb(0)};
        > div:nth-of-type(2) {
            ${pt(0)};
        }
    }
`;
import React, {useEffect, useRef, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation/src/elevation";
import {Container} from "@pg-design/grid-module";
import {flex, onDesktop, pb, pt, pv, textAlign, w100} from "@pg-design/helpers-css";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {debounce} from "@pg-mono/nodash";

import {useStickyIntersection} from "../../hooks/use_sticky_intersection";
import {doubleNavHeight} from "../../offer/components/InvestingOfferListViewNavigation";
import {ILatestQuery} from "../../utils/latest_query";
import {useInvestmentOfferFilters} from "../hooks/use_investment_offer_filters";
import {useInvestmentOfferViewsUrl} from "../hooks/use_investment_offer_views_url";
import {InvestmentOfferListDesktopFilters} from "../list/components/InvestmentOfferListDesktopFilters";

interface IProps {
    latestQuery?: ILatestQuery;
    hideSearchAndFilter?: boolean;
    setInvestmentOffersBlendActive: (active: boolean) => void;
    isMap?: boolean;
}

export const InvestmentListingStickyHeader = (props: IProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const isSticky = useStickyIntersection(wrapperRef);

    const {mapUrl, listUrl} = useInvestmentOfferViewsUrl();
    const {formValues: filtersFormValues, onChange: onFiltersChange} = useInvestmentOfferFilters();

    const [isScrollLowerThanDoubleNavHeight, setIsScrollLowerThanDoubleNavHeight] = useState(true);

    const getScrollPosition = () => {
        if (window.scrollY < doubleNavHeight !== isScrollLowerThanDoubleNavHeight) {
            setIsScrollLowerThanDoubleNavHeight(typeof window !== "undefined" ? window.scrollY < doubleNavHeight : true);
        }
    };
    const debouncedGetScrollPosition = debounce(getScrollPosition, 500);

    useEffect(() => {
        window.addEventListener("scroll", debouncedGetScrollPosition);
        return () => window.removeEventListener("scroll", debouncedGetScrollPosition);
    }, [debouncedGetScrollPosition]);

    return (
        <div ref={wrapperRef} css={[headerWrapperStyle, headerWrapperStickyStyle(isSticky)]}>
            <div css={stickyHeaderWrapperStyle(isSticky)}>
                <Container css={containerStyle}>
                    {!props.hideSearchAndFilter && !!props.latestQuery && (
                        <InvestmentOfferListDesktopFilters
                            onChange={(newFiltersValue) => onFiltersChange(newFiltersValue, true)}
                            setInvestmentOffersBlendActive={props.setInvestmentOffersBlendActive}
                            values={filtersFormValues}
                            isMap={!!props.isMap}
                            listUrl={listUrl}
                            isSticky={isSticky}
                        />
                    )}
                    <Button href={mapUrl} iconLeft={BrandMapPinIcon} variant="brand_icon" size="big" css={buttonStyle}>
                        Zobacz na mapie
                    </Button>
                </Container>
            </div>
        </div>
    );
};

const headerWrapperStyle = css`
    display: none;

    ${onDesktop(css`
        display: block;
        position: sticky;
        top: 0;

        height: 8rem;
        margin-bottom: -8rem;
    `)};
`;

const headerWrapperStickyStyle = (isSticky: boolean) =>
    isSticky
        ? css`
              z-index: 22;
          `
        : css`
              z-index: -1;
          `;

const stickyHeaderWrapperStyle = (isSticky: boolean) =>
    isSticky
        ? css`
              ${elevation(4)};
              ${pv(1)};
              background: white;
              width: 100%;
          `
        : css`
              visibility: hidden;
          `;

const buttonStyle = css`
    transition-duration: unset;
    transition-timing-function: unset;
    overflow: initial;
`;

const containerStyle = css`
    ${textAlign("left")};
    ${flex("center", "flex-start")};
    ${w100};

    > div:first-of-type {
        ${w100};
    }

    .isInNavigationBar {
        ${pb(0)};
        > div:nth-of-type(2) {
            ${pt(0)};
        }
    }
`;
